<template>
	<div class="base-card" :class="{ hoverable, selected }" @click="$emit('click', $event)">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'BaseCard',
	props: {
		hoverable: { type: Boolean, required: false, default: false },
		selected: { type: Boolean, required: false, default: false },
	},
	emits: ['click'],
}
</script>

<style scoped lang="postcss">
.base-card {
	box-sizing: border-box;
	border-radius: var(--card-radius);
	background-color: var(--card-bg);
	border: solid 1px var(--card-border);

	&.hoverable:hover {
		border: 1px solid var(--card-border-hover);
	}
	&.selected {
		border: 1px solid var(--card-border-hover);
	}
}
</style>
